module.exports = __webpack_public_path__ + "img/IPicon22.0c62a77d.png";